/**
 * A company that has moved to the ERIN AI (eAI) employee portal carries, in
 * its whiteLabelSettings JSON, {"mobile": {"mode": "erinai", "url": "https://…"}}.
 * Inside the ERIN mobile shell (ERIN-8561) such a company's users are signed
 * out of this app and the shell is handed the portal URL, so the install
 * starts on the portal from then on. The flag means nothing in a browser.
 *
 * Returns the portal URL when the flag is set and the URL is https, else null.
 */
export const ERINAI_MODE = 'erinai';

export const getShellHandoffUrl = (company) => {
	const settings = company?.whiteLabelSettings;
	const parsed =
		typeof settings === 'string' ? safeParse(settings) : settings || null;
	const mobile = parsed?.mobile;
	if (!mobile || mobile.mode !== ERINAI_MODE) return null;
	const url = typeof mobile.url === 'string' ? mobile.url.trim() : '';
	return isPortalUrl(url) ? url : null;
};

// https only, except a developer's local portal (simulator testing against a
// local erin-engage build; nothing off the machine can be reached that way).
const isPortalUrl = (url) =>
	/^https:\/\//i.test(url) ||
	/^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?\//i.test(url);

// Kept free of src/_shared/services/utils.js so it stays cheap to test.
const safeParse = (value) => {
	try {
		return JSON.parse(value);
	} catch {
		return null;
	}
};

/**
 * True while a signed-in shell user is about to be handed to the portal:
 * their company carries the flag and the sign-out page has not taken over
 * yet (ShellHandoff replaces the location with /logout, where the hand-off
 * itself runs). The router shows the sign-out spinner instead of painting the
 * dashboard for a frame. `inShell` is passed in so this stays a pure function.
 */
export const isLeavingForShellPortal = ({
	auth,
	currentUser,
	pathname,
	inShell,
}) =>
	Boolean(
		auth &&
			inShell &&
			currentUser?.id &&
			pathname !== '/logout' &&
			getShellHandoffUrl(currentUser.company)
	);
